<template>
  <v-container>
    <v-layout row wrap
              fill-height>
      <v-flex class="fill-height xs12">
        <v-progress-linear v-if="loading" indeterminate color="accent" height="4"></v-progress-linear>
        <nx-milenium-form-generator
          v-if="!loading && formConfig"
          :disabled="disabled"
          :config="formConfig"
          :fields-lines="fieldsLines"
          :value="draft"
          :master-channel-values="masterChannelValues"
          @form="updateFormFlags"
          @error="updateFormErrors"
          @input="updateField"
          @linkField="handleLinkField"
        ></nx-milenium-form-generator>
        <img v-if="previewUrl" :src="previewUrl" alt="preview" class="mt-3 page-position-preview">
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import NxMileniumFormGenerator from '@/modules/milenium/components/form/MileniumFormGenerator';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';

export default {
  components: {
    NxMileniumFormGenerator,
  },
  props: {
    contentId: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState('milenium', ['draft', 'fieldsConfig', 'fieldsLines', 'masterChannelValues', 'previewUrl']),
    formConfig() {
      if (!this.fieldsConfig) return null;
      return {
        fieldsConfig: this.fieldsConfig,
      };
    },
  },
  methods: {
    handleLinkField({ field, linkingField }) {
      const linkingValue = linkingField in this.masterChannelValues
        ? this.masterChannelValues[linkingField]
        : this.draft[field].value;
      const fieldValue = {
        ...this.draft[field],
        ...{ value: cloneDeep(linkingValue), linkingField },
      };
      this.updateField(field, fieldValue);
    },
    updateField(field, value) {
      this.$store.dispatch('milenium/UPDATE_FIELDS', { [field]: value });
    },
    updateFormErrors(errors) {
      this.$store.dispatch('milenium/UPDATE_FORM_ERRORS', errors);
    },
    updateFormFlags(flags) {
      this.$store.dispatch('milenium/UPDATE_FORM_FLAGS', flags);
    },
  },
};
</script>

<style lang="stylus" scoped>
.page-position-preview {
  object-fit: contain;
  width: 100%
  max-height: 500px;
}
</style>
